import { render, staticRenderFns } from "./DashboardBoardWidget.vue?vue&type=template&id=540e284e&scoped=true&"
import script from "./DashboardBoardWidget.vue?vue&type=script&lang=ts&"
export * from "./DashboardBoardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBoardWidget.vue?vue&type=style&index=0&id=540e284e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e284e",
  null
  
)

export default component.exports